import React, { useState, useCallback} from "react";
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import {  Link } from 'react-router-dom';
import { CHANGE_PASSWORD } from 'helpers/viewContent';
import * as Path from 'routes/paths';
// imported
import * as Yup from 'yup';
import {updatePassword_} from 'store/services/authService';

const validationSchema = Yup.object().shape({
    old_password: Yup.string().required("Required").min(6, "Password must be at most 6 characters long"),
    new_password: Yup.string().required("Required").min(6, "Password must be at most 6 characters long").notOneOf([Yup.ref("old_password")], "New password must be different from the old password"),
    confirm_password: Yup.string().required("Please confirm your password").oneOf([Yup.ref('new_password'), null], 'Passwords must match'), 
});


const validateData = async (data) => {
    try {
        await validationSchema.validate(data, { abortEarly: false });
        return { isValid: true, errors: {} };
    } catch (error) {
        const errors = {};
        error.inner.forEach((err) => {
            errors[err.path] = err.message;
        });
        return { isValid: false, errors };
    }
};

const ChangePassword = ({dispatch, userProfile}) => {
    const [validationErrors, setValidationErrors] = useState({});
    const [sending, setSending] = useState(false);
 
    const [fields, setfields] = useState({
        old_password: "",
        new_password:"",
        confirm_password: "",
    })
    const handleChange = useCallback(
        name => evt => {
          setfields(prevState => ({
            ...prevState,
            [name]: evt.target.value,
          }))
          setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        },
        []
    )

    //submit setting data
    const handleSubmit = async (evt) => {
    try{
      evt.preventDefault();
      const validation = await validateData(fields);
      if (validation.isValid) {
            setSending(true)
            await dispatch(updatePassword_(fields));
            setSending(false)
            setfields({
                old_password:"",
                new_password:"",
                confirm_password:""
            })
        } else {
            setValidationErrors(validation.errors);
        }
        } catch (err) {
            console.log(err);
            setSending(false)
        }
    }
    
    return(
        <>
        <Helmet title={CHANGE_PASSWORD.CURRENT_MODULE} />
        <div className="page-header">
            <h3 className="page-title">
                <span className="page-title-icon bg-gradient-primary text-white me-2">
                <i className="mdi mdi-lock"></i>
                </span> Change Password
            </h3>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={Path.change_password}>{CHANGE_PASSWORD.CURRENT_MODULE }</Link></li>
                    <li className="breadcrumb-item active" aria-current="page"></li>
                </ol>
            </nav>
        </div>
        <div className="row">
                <div className="col-md-7">
                    <div className="card">
                        <div className="card-body">
                            <form className="forms-sample" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label for="exampleInputName1">Old Password*</label>
                                    <input type="password" className="form-control" id="exampleInputName1" placeholder="******" name="old_password" onChange={handleChange("old_password")}
                                    value={fields.old_password}
                                    />
                                    {validationErrors.old_password && (
                                        <div className="text-danger err">{validationErrors.old_password}</div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label for="exampleInputName1">New Password*</label>
                                    <input type="password" className="form-control" id="exampleInputName1" placeholder="******" name="new_password" onChange={handleChange("new_password")}
                                    value={fields.new_password}
                                    />
                                    {validationErrors.new_password && (
                                        <div className="text-danger err">{validationErrors.new_password}</div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label for="exampleInputName1">Confirm Password*</label>
                                    <input type="password" className="form-control" id="exampleInputName1" placeholder="******" name="confirm_password" onChange={handleChange("confirm_password")}
                                    value={fields.confirm_password}
                                    />
                                    {validationErrors.confirm_password && (
                                        <div className="text-danger err">{validationErrors.confirm_password}</div>
                                    )}
                                </div>
                               
                            <button type="submit" disabled={sending ? true : false} className="btn btn-gradient-primary me-2">{sending ?  'Loading...' : 'Update'}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
const mapStateToPros = (state) => {
    return{
        userProfile: state.Auth.user
    }
};
function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(ChangePassword);